// eslint-disable-next-line import/order
import "./instrument"

import Hotjar from "@hotjar/browser"
import React from "react"
import ReactDOM from "react-dom/client"

import App from "./App"

Hotjar.init(parseInt(import.meta.env.VITE_HOTJAR_ID), 6)

// TODO: when upgrading to react 19: https://docs.sentry.io/platforms/javascript/guides/react/#react-19-error-reporting

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
